<template>
  <div class="wrapper">
    <div class="effective">
      <!-- 左半部分 -->
      <div class="left-effective">
        <div class="">
          <div class="title-effective">
            企业名称：
          </div>
          <div class="context">
            {{WarnInfoData.BRCompanyName}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            经营范围：
          </div>
          <div class="context">
            {{WarnInfoData.BRSecInvSort}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            第二类医疗器械备案凭证
          </div>
          <div class="" style="  position: relative;left: -20px;top: -40px;">
            <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title="" :BLPhotoURL="WarnInfoData.BRPhotoURL" ></CommonuploadEnclosure>
          </div>
        </div>
      
      </div>
      <!--右半部分-->
      <div class="right-effective">
        <div class="">
          <div class="title-effective">
            经营方式：
          </div>
          <div class="context">
            {{WarnInfoData.BRBusinessMode}}
          </div>
        </div>
        <div class="border-context" >
          <div class="title-effective">
            备案日期：
          </div>
          <div class="context">
            {{WarnInfoData.BRFilingDate}}
          </div>
        </div>
      </div>
    </div>
    <div class="reject-Overdue">
      <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
       <span v-html="$options.filters.filters2(WarnInfoList.StringMessage)">
      </span>
    </div>
  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
      type: undefined
    },
     WarnInfoList: {
      type: Object
    }
  },
  data() {
    return {

    }
  },
   filters: {
    filters2(arg) {
      let args = null
      if (arg) {
        args = arg.replace('<span style=\"\"color: #E71D43\"\">', '<span style="color: #E71D43">')
      }
      return args;
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>